import { Injectable } from "@angular/core";

@Injectable()
export class AcmicService {
  stateCode: string;
  project: boolean;
  constructor() {
    this.project = this.getProject();
  }

  isACMIC() {
    return this.project;
  }
  getProject() {
    const state = this.getParameterByName("stateCode");
    if (
      window &&
      window.location &&
      (state === 'ACMIC' || window.location.origin.includes("b2cacmic") ||
        window.location.origin.includes("aaa.com") || window.location.href.includes("aaa.com"))
    ) {
      return true;
    } else {
      return false;
    }
  }
  getParameterByName(name) {
    if (window && window.location) {
      const url = window.location.href;
      name = name.replace(/[[\]]/g, "\\$&");
      const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return "";
      }
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    return null;
  }
}